import React, { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import axios from "axios";
import {
    FETCH_CURRENCY,
    FETCH_COUNSUMER_LIST,
    NODE_API_URL,
} from "./../../../../../env_config";
import { IoSearchSharp } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { useSessionModal } from "../../../../../contexts/SessionModalContext";
import { makeStyles } from "@material-ui/core";

export function UserProfileDropdown(props) {
    const { startSession } = useSelector((state) => state.CcModeSettingReducer);

    const { themeData } = props;

    const useStyles = makeStyles((theme) => ({
        userBtn: {
            '&:hover': {
                backgroundColor: themeData?.nav_bar_color ? `${themeData?.nav_bar_color} !important` : '#fff',
            },
        }

    }));

    const classes = useStyles();

    const { openSessionModal } = useSessionModal();
    const [name, setName] = React.useState([]);
    const userData = useMemo(() => localStorage.getItem("userData"), []);
    const user = JSON.parse(userData);
    const history = useHistory();
    const id = useMemo(() => localStorage.getItem("C_id"), []);
    const consumerSessionId = useMemo(
        () => JSON.parse(localStorage.getItem("consumerSessionId")),
        []
    );

    React.useEffect(() => {
        const getShortListData = async () => {
            axios({
                method: "GET",
                url: `${FETCH_COUNSUMER_LIST}/${user.CustomerId}?userId=${user.userId}`,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem(
                        "accessToken"
                    )}`,
                },
            })
                .then(function(res) {
                    if (res.data.message === "UnAuthorized") {
                        localStorage.clear();
                        window.location.reload(true);
                    }
                    let name = res.data.filter((ele) => {
                        if (ele.ConsumerId == id) return ele;
                    });
                    if (name.length ? name : "") setName(name[0].ListName);
                })
                .catch(function(res) {
                    console.log(res);
                });
        };
        setTimeout(() => {
            getShortListData();
        });
    }, [id]);

    function getCurrency() {
        const currencyData = { Currency: user.Currency };
        axios({
            method: "POST",
            url: FETCH_CURRENCY,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            data: currencyData,
        })
            .then(function(res) {
                if (res.data.message === "UnAuthorized") {
                    localStorage.clear();
                    window.location.reload(true);
                }
            })
            .catch(function(res) {
                console.error(res);
            });
    }

    function selectSession() {
        openSessionModal();
    }

    function endSession() {
        const finalData = {
            ConsumerId: id,
            CustomerId: user.CustomerId,
            Action: "Session Ended",
        };
        axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/storeWhiteLabelConsumerDetails`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            data: finalData,
        })
            .then((res) => {
                if (res.data.message === "UnAuthorized") {
                    localStorage.clear();
                    window.location.reload(true);
                }
            })
            .catch((err) => {});

        // end consumer session
        if (consumerSessionId && consumerSessionId > 0) {
            axios({
                method: "POST",
                url: `${NODE_API_URL}/ccmode/ccmode-end-session`,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem(
                        "accessToken"
                    )}`,
                },
                data: {
                    consumerSessionId: consumerSessionId,
                    closeAction: "End Session Button",
                },
            })
                .then((res) => {
                    if (res.data.message === "UnAuthorized") {
                        localStorage.clear();
                        window.location.reload(true);
                    }
                })
                .catch((err) => {});
        }

        window.localStorage.setItem("C_id", -1);
        localStorage.removeItem("consumerSessionId");
        localStorage.removeItem("consumerSessionCurrency");
        setTimeout(() => {
            setTimeout(() => {
                window.location.reload(true);
            }, 100);
            history.push({ pathname: "/searchdiamond" });
        }, 500);
    }

    const handleLogout = async () => {
        // End consumer session if applicable
        if (consumerSessionId && consumerSessionId > 0) {
            try {
                const res = await axios({
                    method: "POST",
                    url: `${NODE_API_URL}/ccmode/ccmode-end-session`,
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem(
                            "accessToken"
                        )}`,
                    },
                    data: {
                        consumerSessionId,
                        closeAction: "Logout",
                    },
                });

                if (res.data.message === "UnAuthorized") {
                    localStorage.clear();
                    window.location.reload(true);
                    return;
                }
            } catch (err) {
                console.error("Error ending consumer session");
            }
        }

        history.push("/logout");
    };

    return (
        <Dropdown drop="down" alignRight>
            {user ? (
                <>
                    <Dropdown.Toggle
                        as={DropdownTopbarItemToggler}
                        id="dropdown-toggle-user-profile"
                    >
                        <div
                            onClick={() => getCurrency()}
                            className={
                                `btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 ${classes.userBtn}`
                            }
                        >
                            <span className="symbol symbol-35 symbol-light-primary symbol-circle">
                                <span className="symbol-label font-size-h5 font-weight-bold">
                                    <i className="flaticon2-user text-primary"></i>
                                </span>
                                {id === "-1" || id === "-2" || id === "" ? (
                                    <>
                                        <i className="symbol-badge symbol-badge-bottom bg-danger"></i>
                                    </>
                                ) : (
                                    <>
                                        <i className="symbol-badge symbol-badge-bottom bg-success"></i>
                                    </>
                                )}
                            </span>
                        </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                        className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-sm"
                        style={{ width: "auto", backgroundColor: themeData?.nav_bar_color ? themeData?.nav_bar_color : "#fff" }}
                    >
                        <div className="navi navi-spacer-x-0 pt-5">
                            <div className="navi-item px-8">
                                <div className="navi-link">
                                    <div className="navi-text text-center">
                                        <div
                                            className="font-size-h6 font-weight-bold"
                                            style={{
                                                textOverflow: "ellipsis",
                                                width: "160px",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {user.userName}
                                        </div>
                                        <span className="small font-weight-bold">
                                            {user.mail}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="separator separator-solid"></div>
                            <div className="navi-item px-8">
                                <div className="navi-link">
                                    <div className="navi-text text-center">
                                        <div className="small font-weight-bold">
                                            {props.language.CCMODE_HEADER_TIMEZONE}
                                        </div>
                                        <span className="font-size-h6 font-weight-bold">
                                            {user.timeZone
                                                ? user.timeZone
                                                : "Etc/GMT"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="separator separator-solid"></div>
                            <Link
                                to="/searchdiamond"
                                className="navi-item px-8"
                            >
                                <div className="navi-link">
                                    <div className="navi-icon mr-2">
                                        <IoSearchSharp className="text-primary" />
                                    </div>
                                    <div className="navi-text">
                                        <div className="font-weight-bold">
                                            {
                                                props.language
                                                    .CCMODE_USERDROPDOWN_SEARCHDIAMONDS
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            {id === "-1" || id === "-2" || id === "" ? (
                                <>
                                    {startSession ? (
                                        <div
                                            onClick={() => selectSession()}
                                            className="navi-item px-8 cursor-pointer"
                                        >
                                            <div className="navi-link">
                                                <div className="navi-icon mr-2">
                                                    <i className="flaticon2-list-1 text-primary"></i>
                                                </div>
                                                <div className="navi-text">
                                                    <div className="font-weight-bold">
                                                        {
                                                            props.language
                                                                .CCMODE_USERDROPDOWN_STARTSESSION
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </>
                            ) : (
                                <>
                                    <div
                                        onClick={() => endSession()}
                                        className="navi-item px-8 cursor-pointer"
                                    >
                                        <div className="navi-link">
                                            <div className="navi-icon mr-2">
                                                <i className="flaticon2-delete text-danger"></i>
                                            </div>
                                            <div className="navi-text">
                                                <div className="font-weight-bold">
                                                    {
                                                        props.language
                                                            .CCMODE_USERDROPDOWN_ENDSESSION
                                                    }
                                                </div>
                                                <span className=" font-weight-bold text-nowrap text-success">
                                                    ({name})
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div
                                className="navi-item px-8 mb-5"
                                style={{ cursor: "pointer" }}
                                onClick={handleLogout}
                            >
                                <div className="navi-link">
                                    <div className="navi-icon mr-2">
                                        <LuLogOut className="text-primary" />
                                    </div>
                                    <div className="navi-text">
                                        <div className="font-weight-bold">
                                            {
                                                props.language
                                                    .CCMODE_USERDROPDOWN_SIGNOUT
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dropdown.Menu>
                </>
            ) : (
                ""
            )}
        </Dropdown>
    );
}
